import $axios from '@/services/axios';

export default {
    getMe: () => $axios.get('/me').then(res => res.data).catch(() => false),

    createPratica: (scontrino) => $axios.post('/pratica', {
        scontrino: scontrino,
    }),
    ocr: (pratica, tipo_documento, image) => $axios.post('/ocr', {
        pratica: pratica,
        tipo_documento: tipo_documento,
        fronte: image,
    }),
    check: (pratica, fields) => $axios.post('/check', {
        pratica: pratica,
        fields: fields,
    }),
    sign: (pratica, firma) => $axios.post('/sign', {
        pratica: pratica,
        firma: firma,
    }),
};
